import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import { uri } from "../../help/Api";
import { useTranslation } from "react-i18next";

export function useBackupDB() {
  const { t } = useTranslation(["forms"]);
  const [fetching, setFetching] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetch = async () => {
    setFetching(true);
    setIsError(false);
    await axios
      .get(uri + "BackupDB")
      .then(async (res) => {
        console.log(res.data);
        toast.success(t("backup-success"));
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          t("backup-error")
        );
        setIsError(true);
      });
    setFetching(false);
  };

  return { fetch, fetching, isError };
}
